export const appLink: string = "https://app.votex.fi"